import { IgCheckbox } from "@intelligems/ig-theme/IgCheckbox";
import { IgTypography } from "@intelligems/ig-theme/IgTypography";
import { ExperienceCategory } from "@intelligems/ig-types/dtos/experience-categories";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";

import { ThemeExperienceWarningBanner } from "./ThemeExperienceWarningBanner";
import { themeAcknowledgementLabel, ThemeWarningContext } from "./copy";

interface ThemeExperienceAcknowledgementProps {
  category: ExperienceCategory;
  context: ThemeWarningContext;
  isChecked: boolean;
  onCheckboxChange: (checked: boolean) => void;
  /** Resolved via `useThemeExperienceThemeNames`; `[]` falls back to generic copy. */
  themeNames: string[];
}

export const ThemeExperienceAcknowledgement = ({
  category,
  context,
  isChecked,
  onCheckboxChange,
  themeNames,
}: ThemeExperienceAcknowledgementProps) => (
  <Stack direction={"column"} spacing={4}>
    <ThemeExperienceWarningBanner
      category={category}
      context={context}
      themeNames={themeNames}
    />
    <Grid
      container
      direction={"row"}
      columnSpacing={2}
      alignItems={"flex-start"}
    >
      <Grid>
        <IgCheckbox
          checked={isChecked}
          onChange={(e) => onCheckboxChange(e.target.checked)}
        />
      </Grid>
      <Grid size={"grow"} mt={1}>
        <IgTypography>
          {themeAcknowledgementLabel(context, category, themeNames)}
        </IgTypography>
      </Grid>
    </Grid>
  </Stack>
);
